import { render, staticRenderFns } from "./Type_of_Field.vue?vue&type=template&id=6f77a0d4&scoped=true"
import script from "./Type_of_Field.vue?vue&type=script&lang=js"
export * from "./Type_of_Field.vue?vue&type=script&lang=js"
import style0 from "./Type_of_Field.vue?vue&type=style&index=0&id=6f77a0d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f77a0d4",
  null
  
)

export default component.exports